import React, { useState } from "react";

import FilterTurnos from "../../components/FilterTurnos";

import { Table } from "antd";
import { Badge } from "antd";
import WidgetBar from "../../components/WidgetBar";

import Navbar from "../../components/Navbar";

const moment = require("moment");
require("moment/locale/es");
moment.locale("ES");

const capitalizeFirst = require("../../utils/capitalizeFirst");

const Cierres = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Codigo Turno",
      dataIndex: "CodigoTurno",
      key: "CodigoTurno",
      width: "2%",
    },
    {
      title: "Dia",
      dataIndex: "StartDate",
      key: "StartDate",
      width: "5%",
      render: (_, record) => {
        return capitalizeFirst(
          moment(record.StartDate).locale("es").format("dddd")
        );
      },
    },
    {
      title: "Fecha",
      dataIndex: "StartDate",
      key: "StartDate",
      width: "5%",
      render: (_, record) => {
        return moment(record.StartDate).format("L");
      },
    },
    {
      title: "Inicio",
      dataIndex: "StartDate",
      key: "StartDate",
      width: "3%",
      render: (_, record) => {
        return {
          props: {
            style: {
              background: "",
              color: "#2B7A0B",
              fontWeight: 600,
              align: "right",
            },
          },
          children: (
            <div className="green">{moment(record.StartDate).format("LT")}</div>
          ),
        };
      },
    },
    {
      title: "Fin",
      dataIndex: "address",
      key: "address6",
      width: "3%",
      render: (_, record) => {
        if (record.EndDate) {
          return {
            props: {
              style: {
                background: "",
                color: "#B22727",
                fontWeight: 600,
              },
            },
            children: (
              <div className="red">{moment(record.EndDate).format("LT")}</div>
            ),
          };
        } else {
          return "No record";
        }
      },
    },
    {
      title: "Apertura",
      dataIndex: "usuarioApertura",
      key: "usuarioApertura",
      width: "130px",
      render: (_, record) => {
        return record.usuarioApertura;
      },
    },
    {
      title: "Dinero Inicial",
      dataIndex: "DineroInicialCajon",
      key: "DineroInicialCajon",
      width: "100px",
      render: (_, record) => {
        if (record.DineroInicialCajon) {
          return {
            props: {
              style: {
                background: "",
                color: "#2B7A0B",
                fontWeight: 600,
              },
            },
            children: <div className="green">{record.DineroInicialCajon}</div>,
          };
        } else {
          return "No record";
        }
      },
      align: "right",
    },

    {
      title: "Gastos",
      dataIndex: "",
      key: "address4",
      width: "90px",
      render: (_, record) => {
        let totalGastos = record.total_gastos;
        let withBadge = (
          <Badge
            style={{}}
            count={record.cant_gastos}
            offset={[8, 0]}
            size={"small"}
          >
            <div className="red">{totalGastos}</div>
          </Badge>
        );

        let woBadge = <div className="red">{totalGastos}</div>;
      },

      title: "Retiros",
      dataIndex: "",
      key: "address4",
      width: "90px",
      render: (_, record) => {
        let totalRetiros = record.total_retiros;

        let withBadge = (
          <Badge
            style={{}}
            count={record.cant_retiros}
            offset={[8, 0]}
            size={"small"}
          >
            <div className="red">{totalRetiros}</div>
          </Badge>
        );

        let woBadge = <div className="red">{totalRetiros}</div>;

        const retiro = () => {
          if (record.cant_retiros > 1) {
            return withBadge;
          } else {
            return woBadge;
          }
        };

        if (record.cant_retiros) {
          return {
            props: {
              style: {
                // background: "white",
                color: "red",
                fontWeight: 550,
              },
            },
            children: retiro(),
          };
        } else {
          return "No record";
        }
      },
      align: "right",
    },

    {
      title: "Fecha Cierre",
      dataIndex: "address",
      key: "address6",
      width: "10%",
      render: (_, record) => {
        if (record.EndDate) {
          return {
            props: {
              style: {
                background: "",
                color: "",
                // fontWeight: 550,
              },
            },
            children: (
              <div>{moment(record.fechaCierre).format("LT [-] L")}</div>
            ),
          };
        } else {
          return "No record";
        }
      },
    },
    {
      title: "Cierre",
      dataIndex: "usuarioCierre",
      key: "usuarioCierre",
      width: "130px",
      render: (_, record) => {
        return record.usuarioCierre;
      },
    },

    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: () => <a>Delete</a>,
    },
  ];

  const retiroColumns = [
    {
      title: "Number",
      dataIndex: "Date",
      key: "name",
      render: (_, record, i) => {
        return <div>{i + 1}</div>;
      },
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "age",
    },

    {
      title: "Monto",
      dataIndex: "Debit",
      key: "address",
      render: (_, record, i) => {
        return <div>${record.Debit.toFixed(0)}</div>;
      },
    },
    {
      title: "Usuario",
      dataIndex: "UserName",
      key: "address",
    },
  ];

  return (
    <div className="container">
      <Navbar />
      <WidgetBar></WidgetBar>
      <FilterTurnos setData={setData} setLoading={setLoading} />
      <h1>Cierres</h1>

      {console.log(data)}
      {data.length > 0 && (
        <div>
          <h3> Reporte de turno de {data[0].name}</h3>
          <Table
            rowClassName={(record, index) =>
              index % 2 === 0 ? "light" : "dark"
            }
            columns={columns}
            expandable={{
              expandedRowRender: (record) => (
                <div>
                  <div>
                    <h4>Detalle de Gastos</h4>
                    <div className="expandable-table">
                      <p className="total">
                        Total de Gastos ${record.total_gastos}
                      </p>
                    </div>
                  </div>
                  <div>
                    <h4>Detalle de Retiros</h4>
                    <div className="expandable-table">
                      <Table
                        columns={retiroColumns}
                        dataSource={record.retiros}
                        size="small"
                        pagination={false}
                      />
                      <p className="total">
                        Total de Retiros ${record.total_retiros}
                      </p>
                    </div>
                  </div>
                </div>
              ),
              rowExpandable: (record) => record.name !== "Not Expandable",
            }}
            dataSource={data[0].turnos}
            rowKey="CodigoTurno"
          />
        </div>
      )}
    </div>
  );
};

export default Cierres;
